import { forwardRef } from "react";

type Variant = "loop" | "static";

type Props = {
  width?: number | string;
  variant?: Variant;
  className?: string;
  id?: string;
};

const ReportHubLogo = forwardRef<SVGSVGElement, Props>(
  ({ width = 520, variant = "static", className, id }, ref) => {
    const loop = variant === "loop";
    return (
      <svg
        ref={ref}
        id={id}
        width={width}
        viewBox="0 0 310 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        overflow="visible"
        aria-label="Report Hub"
        role="img"
      >
        <text x="10" y="65" className="rh-logo-text">
          Rep
        </text>
        <circle
          className={`rh-mag-circle${loop ? " rh-mag-circle--loop" : ""}`}
          cx="119"
          cy="51"
          r="12"
          fill="none"
          stroke="#1DB5E7"
          strokeWidth="3"
          {...(loop
            ? { strokeDasharray: "75.4", strokeDashoffset: "75.4" }
            : {})}
        />
        <line
          className={`rh-mag-handle${loop ? " rh-mag-handle--loop" : ""}`}
          x1="109"
          y1="61"
          x2="97"
          y2="73"
          stroke="#1DB5E7"
          strokeWidth="3"
          strokeLinecap="round"
          opacity={loop ? 0 : 1}
        />
        <text x="133" y="65" className="rh-logo-text">
          rt Hub
        </text>
        <text x="289" y="28" className="rh-logo-mark">
          &#174;
        </text>
      </svg>
    );
  }
);

ReportHubLogo.displayName = "ReportHubLogo";

export default ReportHubLogo;
